// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared look of the detail/edit pages (resident, building): tinted page background,
 * white rounded cards with a title and an optional description. Loaded with @use by each
 * page stylesheet, so the rules stay scoped to that page. */
ion-content {
  /* Opaque tint (grey layer over the page colour): a transparent background lets the
   * previous page show through during the page transition */
  --background: linear-gradient(rgba(var(--ion-color-medium-rgb), 0.06), rgba(var(--ion-color-medium-rgb), 0.06)),
    var(--ion-background-color, #fff);
  --padding-start: var(--ion-safe-area-left);
  --padding-end: var(--ion-safe-area-right);
  --padding-bottom: var(--ion-safe-area-bottom);
}

.edit-card {
  padding: 20px;
  border-radius: 14px;
  background: var(--ion-background-color, #fff);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
}
.edit-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 17px;
  font-weight: 600;
}
.edit-card__title ion-icon {
  font-size: 20px;
  color: var(--ion-color-primary);
}
.edit-card__description {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.45;
  color: var(--ion-color-medium-shade);
}

/* Summary at the top of a card: round tinted icon, name and a one-line detail (building) */
.building-summary {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 16px;
  margin-bottom: 18px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.building-summary__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.14);
}
.building-summary__icon ion-icon {
  font-size: 26px;
}
.building-summary__info {
  min-width: 0;
}
.building-summary__info h2 {
  margin: 0 0 2px;
  font-size: 18px;
  font-weight: 600;
}
.building-summary__info p {
  margin: 0;
  font-size: 14px;
  color: var(--ion-color-medium-shade);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host {
  display: block;
}

.settings-card form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Language */
.setting-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.setting-block__label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}
.setting-block__label ion-icon {
  font-size: 18px;
  color: var(--ion-color-primary);
}

.languages {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

.language {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.3);
  background: var(--ion-background-color, #fff);
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.language:hover {
  border-color: rgba(var(--ion-color-primary-rgb), 0.5);
}
.language--active, .language--active:hover {
  border-color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.07);
}
.language ion-radio {
  flex-shrink: 0;
}
.language__flag {
  flex-shrink: 0;
  border-radius: 3px;
  object-fit: cover;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.language__name {
  font-size: 14px;
  font-weight: 500;
}
.language--active .language__name {
  font-weight: 600;
}

/* Kiosk settings: one row per setting, the control on the right */
.settings-rows {
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
  border-radius: 12px;
  overflow: hidden;
}

.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 56px;
  padding: 8px 14px;
  cursor: pointer;
}
.setting-row + .setting-row {
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);
}
.setting-row--field {
  cursor: default;
}
.setting-row__text {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 14.5px;
  line-height: 1.35;
}
.setting-row__text ion-icon {
  flex-shrink: 0;
  font-size: 19px;
  color: var(--ion-color-primary);
}
.setting-row ion-toggle {
  flex-shrink: 0;
}

/* Small bordered input on the right of a row (password, minutes) */
.inline-field {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 170px;
  height: 40px;
  padding: 0 4px 0 12px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);
  background: var(--ion-background-color, #fff);
}
.inline-field:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);
}
.inline-field--short {
  width: 80px;
  padding-right: 12px;
}
.inline-field input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--ion-text-color, #000);
  font: inherit;
  font-size: 15px;
  cursor: pointer;
}
.inline-field--short input {
  text-align: right;
  cursor: text;
}
.inline-field__button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
}
.inline-field__button ion-icon {
  font-size: 18px;
}
.inline-field__button:hover {
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}

/* Phones: long labels push the field under the text */
@media (max-width: 480px) {
  .setting-row--field {
    flex-wrap: wrap;
  }
  .inline-field:not(.inline-field--short) {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_edit-card.scss","webpack://./src/components/general%20components/options-settings-generic/options-settings-generic.component.scss","webpack://./src/components/general components/options-settings-generic/options-settings-generic.component.scss"],"names":[],"mappings":"AAAA;;4DAAA;AAIA;EACE;4DAAA;EAEA;qCAAA;EAEA,0CAAA;EACA,yCAAA;EACA,6CAAA;ACAF;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,yDAAA;ACAF;ADEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;ACAJ;ADEI;EACE,eAAA;EACA,+BAAA;ACAN;ADIE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;ACFJ;;ADMA,2FAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,gEAAA;ACHF;ADKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oDAAA;ACHJ;ADKI;EACE,eAAA;ACHN;ADOE;EACE,YAAA;ACLJ;ADOI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;ACLN;ADQI;EACE,SAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACNN;;AC1EA;EACE,cAAA;AD6EF;;AC1EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AD6EF;;AC1EA,aAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AD6EF;AC3EE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AD6EJ;AC3EI;EACE,eAAA;EACA,+BAAA;AD6EN;;ACxEA;EACE,aAAA;EACA,4DAAA;EACA,QAAA;AD2EF;;ACxEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,wDAAA;EACA,6CAAA;EACA,eAAA;EACA,gEAAA;AD2EF;ACzEE;EACE,qDAAA;AD2EJ;ACxEE;EAEE,sCAAA;EACA,oDAAA;ADyEJ;ACtEE;EACE,cAAA;ADwEJ;ACrEE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;ADuEJ;ACpEE;EACE,eAAA;EACA,gBAAA;ADsEJ;ACnEE;EACE,gBAAA;ADqEJ;;ACjEA,kEAAA;AACA;EACE,yDAAA;EACA,mBAAA;EACA,gBAAA;ADoEF;;ACjEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;ADoEF;AClEE;EACE,6DAAA;ADoEJ;ACjEE;EACE,eAAA;ADmEJ;AChEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;ADkEJ;AChEI;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ADkEN;AC9DE;EACE,cAAA;ADgEJ;;AC5DA,mEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,yDAAA;EACA,6CAAA;AD+DF;AC7DE;EACE,sCAAA;EACA,8DAAA;AD+DJ;AC5DE;EACE,WAAA;EACA,mBAAA;AD8DJ;AC3DE;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AD6DJ;AC1DE;EACE,iBAAA;EACA,YAAA;AD4DJ;ACzDE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;AD2DJ;ACzDI;EACE,eAAA;AD2DN;ACxDI;EACE,+BAAA;EACA,mDAAA;AD0DN;;ACrDA,sDAAA;AACA;EACE;IACE,eAAA;EDwDF;ECrDA;IACE,WAAA;EDuDF;AACF","sourcesContent":["/* Shared look of the detail/edit pages (resident, building): tinted page background,\n * white rounded cards with a title and an optional description. Loaded with @use by each\n * page stylesheet, so the rules stay scoped to that page. */\n\nion-content {\n  /* Opaque tint (grey layer over the page colour): a transparent background lets the\n   * previous page show through during the page transition */\n  --background: linear-gradient(rgba(var(--ion-color-medium-rgb), 0.06), rgba(var(--ion-color-medium-rgb), 0.06)),\n    var(--ion-background-color, #fff);\n  --padding-start: var(--ion-safe-area-left);\n  --padding-end: var(--ion-safe-area-right);\n  --padding-bottom: var(--ion-safe-area-bottom);\n}\n\n.edit-card {\n  padding: 20px;\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 12px;\n    font-size: 17px;\n    font-weight: 600;\n\n    ion-icon {\n      font-size: 20px;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  &__description {\n    margin: 0 0 16px;\n    font-size: 14px;\n    line-height: 1.45;\n    color: var(--ion-color-medium-shade);\n  }\n}\n\n/* Summary at the top of a card: round tinted icon, name and a one-line detail (building) */\n.building-summary {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding-bottom: 16px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.14);\n\n    ion-icon {\n      font-size: 26px;\n    }\n  }\n\n  &__info {\n    min-width: 0;\n\n    h2 {\n      margin: 0 0 2px;\n      font-size: 18px;\n      font-weight: 600;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: var(--ion-color-medium-shade);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n}\n","/* Shared look of the detail/edit pages (resident, building): tinted page background,\n * white rounded cards with a title and an optional description. Loaded with @use by each\n * page stylesheet, so the rules stay scoped to that page. */\nion-content {\n  /* Opaque tint (grey layer over the page colour): a transparent background lets the\n   * previous page show through during the page transition */\n  --background: linear-gradient(rgba(var(--ion-color-medium-rgb), 0.06), rgba(var(--ion-color-medium-rgb), 0.06)),\n    var(--ion-background-color, #fff);\n  --padding-start: var(--ion-safe-area-left);\n  --padding-end: var(--ion-safe-area-right);\n  --padding-bottom: var(--ion-safe-area-bottom);\n}\n\n.edit-card {\n  padding: 20px;\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n}\n.edit-card__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  font-size: 17px;\n  font-weight: 600;\n}\n.edit-card__title ion-icon {\n  font-size: 20px;\n  color: var(--ion-color-primary);\n}\n.edit-card__description {\n  margin: 0 0 16px;\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--ion-color-medium-shade);\n}\n\n/* Summary at the top of a card: round tinted icon, name and a one-line detail (building) */\n.building-summary {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding-bottom: 16px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n}\n.building-summary__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.14);\n}\n.building-summary__icon ion-icon {\n  font-size: 26px;\n}\n.building-summary__info {\n  min-width: 0;\n}\n.building-summary__info h2 {\n  margin: 0 0 2px;\n  font-size: 18px;\n  font-weight: 600;\n}\n.building-summary__info p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--ion-color-medium-shade);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n:host {\n  display: block;\n}\n\n.settings-card form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Language */\n.setting-block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.setting-block__label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\n.setting-block__label ion-icon {\n  font-size: 18px;\n  color: var(--ion-color-primary);\n}\n\n.languages {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 8px;\n}\n\n.language {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 46px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.3);\n  background: var(--ion-background-color, #fff);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n.language:hover {\n  border-color: rgba(var(--ion-color-primary-rgb), 0.5);\n}\n.language--active, .language--active:hover {\n  border-color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.07);\n}\n.language ion-radio {\n  flex-shrink: 0;\n}\n.language__flag {\n  flex-shrink: 0;\n  border-radius: 3px;\n  object-fit: cover;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n.language__name {\n  font-size: 14px;\n  font-weight: 500;\n}\n.language--active .language__name {\n  font-weight: 600;\n}\n\n/* Kiosk settings: one row per setting, the control on the right */\n.settings-rows {\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.setting-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 56px;\n  padding: 8px 14px;\n  cursor: pointer;\n}\n.setting-row + .setting-row {\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n}\n.setting-row--field {\n  cursor: default;\n}\n.setting-row__text {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  font-size: 14.5px;\n  line-height: 1.35;\n}\n.setting-row__text ion-icon {\n  flex-shrink: 0;\n  font-size: 19px;\n  color: var(--ion-color-primary);\n}\n.setting-row ion-toggle {\n  flex-shrink: 0;\n}\n\n/* Small bordered input on the right of a row (password, minutes) */\n.inline-field {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 170px;\n  height: 40px;\n  padding: 0 4px 0 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n}\n.inline-field:focus-within {\n  border-color: var(--ion-color-primary);\n  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n}\n.inline-field--short {\n  width: 80px;\n  padding-right: 12px;\n}\n.inline-field input {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: none;\n  background: transparent;\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  cursor: pointer;\n}\n.inline-field--short input {\n  text-align: right;\n  cursor: text;\n}\n.inline-field__button {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n}\n.inline-field__button ion-icon {\n  font-size: 18px;\n}\n.inline-field__button:hover {\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n}\n\n/* Phones: long labels push the field under the text */\n@media (max-width: 480px) {\n  .setting-row--field {\n    flex-wrap: wrap;\n  }\n  .inline-field:not(.inline-field--short) {\n    width: 100%;\n  }\n}","@use \"../../../theme/edit-card\";\n\n:host {\n  display: block;\n}\n\n.settings-card form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Language */\n.setting-block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  &__label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 600;\n\n    ion-icon {\n      font-size: 18px;\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n.languages {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 8px;\n}\n\n.language {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 46px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.3);\n  background: var(--ion-background-color, #fff);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n\n  &:hover {\n    border-color: rgba(var(--ion-color-primary-rgb), 0.5);\n  }\n\n  &--active,\n  &--active:hover {\n    border-color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.07);\n  }\n\n  ion-radio {\n    flex-shrink: 0;\n  }\n\n  &__flag {\n    flex-shrink: 0;\n    border-radius: 3px;\n    object-fit: cover;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  &--active &__name {\n    font-weight: 600;\n  }\n}\n\n/* Kiosk settings: one row per setting, the control on the right */\n.settings-rows {\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.setting-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 56px;\n  padding: 8px 14px;\n  cursor: pointer;\n\n  & + & {\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n\n  &--field {\n    cursor: default;\n  }\n\n  &__text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n    font-size: 14.5px;\n    line-height: 1.35;\n\n    ion-icon {\n      flex-shrink: 0;\n      font-size: 19px;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  ion-toggle {\n    flex-shrink: 0;\n  }\n}\n\n/* Small bordered input on the right of a row (password, minutes) */\n.inline-field {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 170px;\n  height: 40px;\n  padding: 0 4px 0 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n\n  &:focus-within {\n    border-color: var(--ion-color-primary);\n    box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n  }\n\n  &--short {\n    width: 80px;\n    padding-right: 12px;\n  }\n\n  input {\n    flex: 1;\n    min-width: 0;\n    height: 100%;\n    padding: 0;\n    border: 0;\n    outline: none;\n    background: transparent;\n    color: var(--ion-text-color, #000);\n    font: inherit;\n    font-size: 15px;\n    cursor: pointer;\n  }\n\n  &--short input {\n    text-align: right;\n    cursor: text;\n  }\n\n  &__button {\n    display: grid;\n    place-items: center;\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: transparent;\n    color: var(--ion-color-medium);\n    line-height: 0;\n    cursor: pointer;\n\n    ion-icon {\n      font-size: 18px;\n    }\n\n    &:hover {\n      color: var(--ion-color-primary);\n      background: rgba(var(--ion-color-primary-rgb), 0.1);\n    }\n  }\n}\n\n/* Phones: long labels push the field under the text */\n@media (max-width: 480px) {\n  .setting-row--field {\n    flex-wrap: wrap;\n  }\n\n  .inline-field:not(.inline-field--short) {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
